import classNames from "classnames"
import type {
  Ref,
  ComponentPropsWithoutRef,
} from "react"
import { forwardRef } from "react"
import styles from "./UserInitialButton.module.scss"
import { UserName } from "src/components/UserName"
import { followToSharerInitials } from "src/utils"

interface Props extends ComponentPropsWithoutRef<"button"> {
  user: ComponentPropsWithoutRef<typeof UserName>["user"];
}

/*
 * this component renders a button that shows the user's initials in a circle
 */
export const UserInitialButton = forwardRef<HTMLButtonElement, Props>(
  function UserInitialButton(props: Props, propRef: Ref<HTMLButtonElement>) {
    const {
      user,
      className: classNameProp,
      ...buttonProps
    } = props

    const className = classNames(
      classNameProp,
      styles.userInitialButton,
    )

    return (
      <button
        {...buttonProps}
        ref={propRef}
        className={className}
        id="profile"
      >
        <UserName
          user={user}
          transform={followToSharerInitials}
        />
      </button>
    )
  },
)
